import { render, staticRenderFns } from "./PosCashDesk.vue?vue&type=template&id=11ed08a8&scoped=true"
import script from "./PosCashDesk.vue?vue&type=script&lang=js"
export * from "./PosCashDesk.vue?vue&type=script&lang=js"
import style0 from "./PosCashDesk.vue?vue&type=style&index=0&id=11ed08a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed08a8",
  null
  
)

export default component.exports